import React from 'react';
import ReactDOM, {createPortal} from 'react-dom';
import Style from './index.less'
import './index.less'
import classNames from 'classnames'
/**
 * DropDown另外一种实现，比dui有3大优点，而且效果基本和dui一致
 * 1， 不抢焦点
 * 2， 不影响原来控件布局
 * 3， 不会展示前render下拉内容
 * 4， 可以通过改变belongID实现多个控件绑定一个dropDown
 *
 * props参数文档：
 * anchorPoint{x:0,y:0} 或 anchorRect{x:0,y:0,width:0,height:0} : 锚点，当没有指定belongID时，可以指定锚点，标示一个位置
 * belongID ：所属的dom元素的id，即从哪里打开
 * dropContent: 如果不指定children，可以指定dropContent来展示内容
 * hasShadow：是否给drop内容加上阴影和上下间距
 * aligment : 'left' 'right' 'top' 'bottom',和所属dom元素的对齐方式,'screenCenter',屏幕正中
 * autoAlign : boolean值，为true的话会根据上下空间的大小自动展示为top还是bottom
 * matchWidth : 下拉内容是否和所属dom等宽
 * onVisibleChange : 显示隐藏回调监听
 * disabled ：不可打开关闭dropDown
 * scrollable :是否自动计算可否滚动
 * hasTransform : 是否去掉动画的transform属性，dropDown嵌套需要去掉transform
 * shadowType ： 'menu'为menu的阴影效果
 * center : 在所属dom居中位置显示
 * offsetX：正数向右，负数向左偏移
 * offsetY：正数向下，负数向上偏移
 * isTransparent: bool, 背景是否为透明色
 * disableBodyClose: bool, 是否禁用点击body时自动关闭
 */
export default class Dropdown extends React.Component {

    static index = 0;

    /**
     * 使用方法创建DropDown，并返回一个接口对象
     *
     * Dropdown.create({
            anchorPoint: {x:100,y:100},
            dropContent:<LinkEditMenu />,
        }).show()
     *
     * @param config
     * @returns {{show: show, close: close, isShown: isShown}}
     */
    static create( config ) {

        let instance = ReactDOM.render(<Dropdown {...config} closeWhenHide={true}/>, document.createElement('div'));

        function show() {
            if (instance) {
                instance.show();
            }
        }

        function close() {
            if (instance) {
                instance.hide();
            }
            instance = null;
        }

        function isShown() {
            if (instance) {
                return instance.isShown();
            }
            return false;
        }

        function setDisable(dsiable) {
            if (instance) {
                instance.setDisable(dsiable);
            }
        }

        return { show, close, isShown, setDisable};
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            isShown: false,
            hideAnimating : false,
            config: {},  //drop内容位置，大小，是否可滚动等等
        }

        this.id = 'custom-drop-down-id-' + Dropdown.index++;
        this.firstRender = true;  //第一次不渲染内容
        this.hiding = false;
    }

    componentDidMount(){

    }

    componentWillUnmount() {
        this.unmount = true;
        this.removeListener();
    }

    removeListener = ()=>{
        // container事件为了兼容pdf将容器放到iframe里的操作
        const { container } = this.props;
        container && container.removeEventListener("click",this.bodyClickHandler);
        container && container.removeEventListener("mousedown",this.handleMouseDown);
        document.body.removeEventListener("click",this.bodyClickHandler);
        document.body.removeEventListener("mousedown",this.handleMouseDown);
        window.removeEventListener('resize', this.resize);
    }

    componentWillReceiveProps(nextProps){
        if(!this.firstRender){
            this.hookBelongDomClick(nextProps.belongID);
        }
    }

    hookBelongDomClick(belongID){
        const { container } = this.props;
        if(belongID){
            let belongDom = document.getElementById(belongID) || container.querySelector(`#${belongID}`);
            if(!belongDom){
                setTimeout(()=>{  //防止belong dom还没初始化
                    let belongDom =document.getElementById(belongID) || container.querySelector(`#${belongID}`);
                    if(belongDom){
                        belongDom.onclick = ()=>{
                            setTimeout(()=>{
                                this.show();
                            },20)
                        }
                    }
                },100);
            }else{
                if(belongDom){
                    belongDom.onclick = ()=>{
                        setTimeout(()=>{
                            this.show();
                        },20)
                    }
                }
            }
        }
    }

    bodyClickHandler = (e) =>{
        //延迟一下，让body里的元素先执行click
        this.hiding = true;
        setTimeout(()=>{
            if (!this.props.disableBodyClose && this.state.isShown && this.hiding) {
                this.hiding = false;
                let clickOnMenu = false;
                if(this.isClickOnContent(this.downX,this.downY)){
                    clickOnMenu = true;
                }else{
                    clickOnMenu = this.clickOnMenu(e, this.props.maxLevel || 20);
                }
                if(!clickOnMenu){
                    this.hide();
                }
            }
        },50)
    }

    isClickOnContent = (x,y)=>{
        if(this.dropDom){
            // let child = this.dropDom.childNodes[0];
            let rect = this.dropDom.getBoundingClientRect();
            if(x >= rect.left && x <= rect.right
                && y >= rect.top && y <= rect.bottom){
                return true;
            }
        }
        return false;
    }

    //点击的位置是否在菜单组件上
    clickOnMenu = (e , maxLevel) =>{
        let curDom = e.target;
        let level = 0;
        while(curDom && level<maxLevel){
            curDom = curDom.parentNode;
            level++;
            if(curDom && curDom.id && curDom.id.indexOf(this.id)>=0){
                return true;
            }
        }
        return false;
    }

    resize = ()=>{
        this.hide();
    }

    setDisable = (disable)=>{
        this.disabled = disable;
    }

    show = () => {
        if (this.props.disabled || this.disabled) {
            return;
        }
        if (!this.state.isShown) {
            // container事件为了兼容pdf将容器放到iframe里的操作
            const { container } = this.props;
            container && container.addEventListener("click",this.bodyClickHandler)
            container && container.addEventListener("mousedown",this.handleMouseDown)
            document.body.addEventListener("click",this.bodyClickHandler)
            document.body.addEventListener("mousedown",this.handleMouseDown)
            window.addEventListener('resize', this.resize);
            this.setState({
                isShown: true,
                config:{left:0,top:0}
            },()=>{
                this.onVisibleChange(true);
                this.autoAdjustLoc();
            });
        }else{
            let config = this.getNewConfig();
            if(this.hiding && config  && (this.oldLeft!==config.left
                || this.oldRight !== config.right)){  //当做新打开
                this.hiding =false;

                this.setState({
                    config:config
                },()=>{
                    this.autoAdjustLoc(config);
                });
            }
        }

    }

    getReactWithPoint = (point)=>{
        let x = point.x || 0;
        let y = point.y || 0;

        return {
            left: x,
            top: y,
            width: 0,
            height: 0,
            right : x,
            bottom : y,
        }
    }

    getReactWithRect = (rect)=>{
        let x = rect.x || 0;
        let y = rect.y || 0;
        let w = rect.width || 0;
        let h = rect.height || 0;

        return {
            left: x,
            top: y,
            width: w,
            height: h,
            right : x+w,
            bottom : y+h,
        }
    }

    getRect(){
        const { belongID, container, anchorPoint, anchorRect } = this.props;
        let rect;
        if(belongID){
            let belongDom = document.getElementById(belongID) || container.querySelector(`#${belongID}`);
            if(belongDom){
                rect = belongDom.getBoundingClientRect();
            }
        }else if(anchorPoint){
            rect = this.getReactWithPoint(anchorPoint);
        }else if(anchorRect){
            rect = this.getReactWithRect(anchorRect);
        }
        return rect;
    }

    hide = () => {
        if (this.props.disabled || this.disabled) {
            return;
        }
        // console.log('hide menu');
        if (this.state.isShown) {
            this.state.hideAnimating = true;
            setTimeout(()=>{
                if(this.unmount)return;
                this.setState({
                    hideAnimating : false, //动画结束
                })
            },250);
            this.setState({
                isShown: false,
            },()=>{
                this.onVisibleChange(false);
            });
            this.removeListener();
        }
    }

    isShown = () => {
        return this.state.isShown;
    }

    onVisibleChange = (visible)=>{
        if (this.props.onVisibleChange) {
            this.props.onVisibleChange(visible);
        }
    }

    getNewConfig = ()=>{
        const maxHeight = 700;
        const dropDom = this.dropDom;
        let anchorRect = this.getRect()

        if(dropDom && anchorRect){
            let dropRect = dropDom.getBoundingClientRect();
            let vh = document.body.clientHeight;
            let vw = document.body.clientWidth;

            let config = {};

            // 1.调整上下位置
            let top = anchorRect.bottom + 4;
            let bottom = vh - anchorRect.top + 4;

            if(this.props.autoAlign){  //自动调整：下方能显示默认向下显示，否则向上显示
                let menuH = dropRect.height;

                let bottomOffset = vh - top ;
                let topOffset = vh - bottom ;

                if(bottomOffset < menuH && topOffset < menuH){ //上下都无法放置，哪边高放置哪边
                    if(topOffset > bottomOffset){
                        config.bottom = bottom;
                        this.alignment = 'top';
                    }else{
                        config.top = top;
                        this.alignment = 'bottom';
                    }
                }else if(bottomOffset>menuH){
                    config.top = top;
                    this.alignment = 'bottom';
                }else if(topOffset>menuH){
                    config.bottom = bottom;
                    this.alignment = 'top';
                }
            }else{
                if(this.props.aligment === 'top'){
                    config.bottom = bottom;
                }else{
                    config.top = top;
                }
            }

            // 2.调整显示高度
            let scrollable = typeof(this.props.scrollable)==='undefined'?true:this.props.scrollable;
            if(scrollable){
                let isAlignTop = this.props.aligment === 'top' || this.alignment === 'top';
                let menuH = dropRect.height;
                if(isAlignTop){
                    let bottom = config.bottom;
                    if(bottom + menuH >= vh || menuH >= maxHeight){
                        config.scrollable = true;
                        if(menuH>=maxHeight && maxHeight < vh - bottom){
                            config.height = maxHeight;
                        }else{
                            config.height = vh - bottom - 6;
                        }
                    }
                }else{
                    let top = config.top;
                    if(top + menuH >= vh || menuH >= maxHeight){
                        config.scrollable = true;
                        if(menuH>=maxHeight && maxHeight < vh - top){
                            config.height = maxHeight;
                        }else{
                            config.height = vh - top - 6;
                        }
                    }
                }
            }

            if(this.props.center) {
                let left =  anchorRect.left + anchorRect.width/2;
                config.left = left - dropRect.width/2;
            }else{
                if(this.props.aligment === 'right'){
                    config.right = vw - anchorRect.right;
                }else{
                    //默认左对齐
                    config.left = anchorRect.left;
                }
            }

            //3. 调整左右位置
            if(config.left){  //超出左右边界位置调整
                if(config.left + dropRect.width > vw){
                    config.left -= (config.left + dropRect.width + 4) - vw;
                }else if(config.left<4){
                    config.left=4;
                }
            }else if(config.right){ //超出左右边界位置调整
                if(config.right < 0){
                    config.right =  4;
                }else if(vw - config.right  < dropRect.width){
                    config.right += dropRect.width-(vw - config.right) + 4;
                }
            }

            // 此处强制定义一个screenCenter以处理屏幕居中的情况，位置勿动，此时props.center不生效
            if (this.props.aligment === 'screenCenter') {
                config.left = vw / 2;
                config.top = vh / 2;
            }

            if(this.props.offsetX){  //调整x轴offset
                if(config.left){
                    config.left += this.props.offsetX;
                }else if(config.right){
                    config.right -= this.props.offsetX;
                }
            }
            if(this.props.offsetY){  //调整y轴offset
                if(config.top){
                    config.top += this.props.offsetY;
                }else if(config.bottom){
                    config.bottom -= this.props.offsetY;
                }
            }

            return config;
        }

        return null;
    }

    //位置自动调整
    autoAdjustLoc = (newConfig)=>{
        newConfig = newConfig? newConfig : this.getNewConfig();

        this.oldLeft = newConfig.left;
        this.oldRight = newConfig.right;

        this.setState({
            config:newConfig
        });

    }

    getID = ()=>{
        return this.id;
    }

    handleMouseDown = (e)=>{
        this.downX = e.clientX;
        this.downY = e.clientY;
    }

    render() {
        if(!this.state.config)return null;

        let needHide = false;
        if(!this.state.isShown && this.firstRender){
            this.hookBelongDomClick(this.props.belongID);
            return null;
        }else if(this.state.isShown){
            needHide = this.firstRender; //第一次isShown时，页面没有动画，所以这次hide，让其下次render时show让动画出现
            this.firstRender = false;
        }
        let top = this.state.config.top;
        let bottom = this.state.config.bottom;
        let left = this.state.config.left;
        let right = this.state.config.right;
        let width = this.state.config.width;
        let height = this.state.config.height;

        // let transformOrigin = this.props.aligment === 'top' ? 'center bottom' : 'center top';
        let hideTransform = this.props.aligment === 'top' || this.alignment === 'top' ? 'drop-down-hide-transform-top' : 'drop-down-hide-transform'

        let dropStyle = { left: left, top: top, bottom:bottom,right: right , width ,height:height};

        let hasShadow = typeof (this.props.hasShadow) === 'undefined' ? true : this.props.hasShadow;
        let menuShadow = this.props.shadowType || 'default';
        let hasTransform = typeof (this.props.hasTransform) === 'undefined' ? true : this.props.hasTransform;
        let isTransparent = typeof (this.props.isTransparent) === 'undefined' ? false : this.props.isTransparent;

        let dropClass = classNames({
            [Style['drop-down']]: true,
            [Style['drop-down-show-transform']]:hasTransform,
            [Style["drop-down-hidden"]]: !this.state.isShown || needHide,
            [Style[hideTransform]]: (!this.state.isShown || needHide)&&hasTransform,
            [Style["drop-down-shadow"]] : hasShadow && !menuShadow,
            [Style["drop-down-menu-shadow"]] : hasShadow && menuShadow,
            'menu-scroll': this.state.config.scrollable,
            [Style['drop-down-background']]: !isTransparent,
        });

        let dropClassComponent = classNames({
            'drop-down': true,
            'drop-down-show-transform':hasTransform,
            'drop-down-hidden': !this.state.isShown || needHide,
            'hideTransform': (!this.state.isShown || needHide)&&hasTransform,
            'drop-down-shadow' : hasShadow && !menuShadow,
            'drop-down-menu-shadow' : hasShadow && menuShadow,
            'menu-scroll': this.state.config.scrollable,
            'drop-down-background': !isTransparent,
        });

        let container = this.props.container || document.body;

        if(this.props.closeWhenHide){
            if(this.state.isShown || this.state.hideAnimating){
                //do nothing
            }else{
                return null;
            }
        }

        return createPortal(
            <div id={this.id} ref={ref => { this.dropDom = ref }} style={dropStyle} className={dropClass + dropClassComponent} onMouseDown={(e) => { e.nativeEvent.stopPropagation();}} onWheel={(e) => { e.nativeEvent.stopPropagation(); }}>
                {(this.state.isShown || this.state.hideAnimating) ? (this.props.dropContent||this.props.children):null}
            </div>, //塞进传送门的JSX
            container //传送门的另一端DOM node
        );
    }
}
 